import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";

const InfrastructureSection = () => {
  return (
    <Box sx={design.Container}>
      <CustomText
        color="#8625B8"
        fontWeight={500}
        fontFamily="Nunito"
        textAlign="center"
        sx={design.Subtitle}
      >
        Lo que nos hace más que un hospital
      </CustomText>
      <CustomText
        color="#304795"
        fontWeight={700}
        fontFamily="Nunito"
        textAlign="center"
        sx={design.Title}
      >
        Infraestructura que marca la diferencia
      </CustomText>
      <CustomText
        color="#111111"
        fontWeight={500}
        fontFamily="Nunito"
        textAlign="center"
        sx={design.Description}
      >
        Cada etapa representa un paso firme hacia la construcción del hospital
        integral que nuestra comunidad merece
      </CustomText>
      <Grid container sx={design.CardsContainer}>
        <Grid size={design.grid0} />
        {infrastructureData.map((item) => (
          <Grid key={item.title} size={design.grid3} sx={design.GridItem}>
            <Box sx={design.Card}>
              <Box sx={design.ColorStripe(item)} />
              <CustomText
                color={item.color}
                fontWeight={700}
                fontFamily="Nunito"
                sx={design.CardTitle}
              >
                {item.title}
              </CustomText>
              <Box sx={design.CardContent}>
                <Box component="ul" sx={design.List}>
                  {item.items.map((text, index) => (
                    <Box component="li" key={index}>
                      {text}
                    </Box>
                  ))}
                </Box>
                {item.extraText && (
                  <CustomText
                    color="#444444"
                    fontWeight={400}
                    fontFamily="Nunito"
                    sx={design.ExtraText}
                  >
                    {item.extraText}
                  </CustomText>
                )}
              </Box>
              <Box sx={design.ImageContainer}>
                <ImageLoader
                  src={item.image}
                  alt={item.title}
                  width="100%"
                  height="100%"
                  objectPosition={item.objectPosition}
                />
              </Box>
            </Box>
          </Grid>
        ))}
        <Grid size={design.grid0} />
      </Grid>
    </Box>
  );
};

export default InfrastructureSection;

const infrastructureData = [
  {
    title: "Helipuerto",
    color: "#3785E8",
    items: [
      "Tipo H1",
      "Recepción y traslado de pacientes",
      "Operación diurna y nocturna con viabilidad ante la AFAC",
      "Sala de espera médica",
      "Sala de espera VIP",
    ],
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/HelipuertoRender.png",
    objectPosition: "center 10%",
  },
  {
    title: "Proyecto Sostenible",
    color: "#299622",
    items: ["Planta de tratamiento de agua", "Sistema de energía solar"],
    extraText: "Para un hospital más eficiente y responsable",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Proyecto_sostenible_infraestructura.jpg",
    objectPosition: "center 60%",
  },
  {
    title: "Servicios Integrados",
    color: "#D87800",
    items: [
      "Farmacia",
      "Cafetería",
      "Servicios médicos complementarios",
      "Cocina industrial grado médico",
    ],
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Servicios_integrado_Infraestrururaa.png",
    objectPosition: "center 100%",
  },
];

const design = {
  Container: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    overflow: "hidden",
    py: { xs: 5, sm: 6, md: 3 },
  },
  Subtitle: {
    fontSize: { xs: 16, sm: 15, md: 15, lg: 15 },
    lineHeight: 1.2,
    mb: { xs: 1.5, md: 1 },
  },
  Card: {
    width: "98%",
    height: { xs: 360, sm: 300, md: 340, xl: 390 },
    borderRadius: "20px",
    overflow: "hidden",
    backgroundColor: "#E9E7EA",
    position: "relative",
    boxShadow: "0 3px 10px rgba(0,0,0,.08)",
    transition: "all .3s ease",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 12px 30px rgba(0,0,0,.14)",
    },
  },
  Title: {
    fontSize: { xs: 35, sm: 36, md: 40, lg: 43 },
    lineHeight: 1.15,
    letterSpacing: "-0.5px",
    mb: { xs: 1.5, md: 1.5 },
  },
  Description: {
    fontSize: { xs: 17, sm: 15, md: 16, lg: 17 },
    lineHeight: 1.4,
    mx: "auto",
    mb: { xs: 4, sm: 5, md: 4 },
  },
  CardsContainer: {
    mx: "auto",
    justifyContent: "center",
    alignItems: "stretch",
  },
  GridItem: {
    display: "flex",
    justifyContent: "center",
    mt: 2,
  },
  ColorStripe: (item) => ({
    position: "absolute",
    top: 0,
    right: 0,
    width: "31px",
    height: "100%",
    zIndex: 5,
    borderRadius: "0 20px 20px 0",
    backgroundColor: item.color,
  }),
  CardContent: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "calc(100% - 31px)",
    height: "134px",
    flexShrink: 0,
    boxSizing: "border-box",
    px: { xs: 2, sm: 2, md: 2 },
    pb: 1,
    overflow: "hidden",
    zIndex: 2,
  },
  CardTitle: {
    fontSize: { xs: 22, sm: 23, md: 28 },
    lineHeight: 1.1,
    display: "inline-block",
    textDecoration: "underline",
    textUnderlineOffset: "5px",
    textDecorationThickness: "2px",
    alignItems: "stretch",
    textAlign: "left",
    mb: 1,
    paddingLeft: "20px",
    paddingTop: "10px",
    whiteSpace: "nowrap",
  },
  List: {
    m: 0,
    paddingLeft: "17px",
    color: "#3F3F3F",
    fontFamily: "Nunito",
    fontSize: { xs: 13, sm: 13.5, md: 16 },
    lineHeight: 1.18,
    "& li::marker": {
      fontSize: "12px",
    },
  },
  ExtraText: {
    fontSize: { xs: 13, sm: 13, md: 16 },
    lineHeight: 1.15,
    textAlign: "center",
    mt: 1.5,
    px: 1,
  },
  ImageContainer: {
    position: "relative",
    width: "calc(110% - 31px)",
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
    zIndex: 1,
  },
  grid3: { xs: 11, sm: 3, md: 3, lg: 3 },
  grid0: { xs: 0.5, sm: 0, md: 0, lg: 0 },
};
